import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useWatch } from 'react-hook-form';

import { useContactInfo } from 'reservations/account/providers/ConfigProvider';
import { getMaxPartySizeText } from 'reservations/availabilities/helpers/getMaxPartySizeText';
import { SOY } from 'reservations/brand/constants';

export const MaxPartySizeText = () => {
  const { emailAddress, phoneNumber } = useContactInfo();
  const partySize = useWatch({
    name: 'partySize'
  });
  const { message, LinkComponent } = getMaxPartySizeText(
    emailAddress,
    phoneNumber,
    partySize
  );

  return (
    <Box sx={{ p: '16px' }}>
      <Typography
        data-testid="max-party-size-text"
        sx={{
          color: SOY,
          fontSize: '16px',
          textAlign: 'center'
        }}
      >
        {message}
        {LinkComponent}
      </Typography>
    </Box>
  );
};
